var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevrondown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4504 9.88778L12.2629 17.0753C12.1627 17.1758 12.0437 17.2555 11.9126 17.31C11.7816 17.3644 11.6411 17.3924 11.4992 17.3924C11.3573 17.3924 11.2168 17.3644 11.0857 17.31C10.9547 17.2555 10.8357 17.1758 10.7355 17.0753L3.54801 9.88778C3.34547 9.68524 3.23169 9.41054 3.23169 9.12411C3.23169 8.83767 3.34547 8.56297 3.54801 8.36043C3.75055 8.1579 4.02525 8.04411 4.31168 8.04411C4.59812 8.04411 4.87282 8.1579 5.07536 8.36043L11.5001 14.7852L17.9248 8.35954C18.1273 8.157 18.402 8.04321 18.6885 8.04321C18.9749 8.04321 19.2496 8.157 19.4522 8.35954C19.6547 8.56208 19.7685 8.83678 19.7685 9.12321C19.7685 9.40964 19.6547 9.68434 19.4522 9.88688L19.4504 9.88778Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrondown);
export default __webpack_public_path__ + "static/media/chevrondown.d780f64dd0e48852499d9de9f9f7600b.svg";
export { ForwardRef as ReactComponent };